import { PageWithLayout } from '@/pages/_app';
import { Helmet } from 'react-helmet-async';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { WebshopsPageContent } from '@/pageContents/webshopsContent/WebshopsPageContent';
import { Permission } from '@/models/user';

const WebshopsPage: PageWithLayout = () => {
    return (
        <>
            <Helmet>Webshops | Starjack Backoffice</Helmet>

            <WebshopsPageContent />
        </>
    );
};

WebshopsPage.isProtected = true;
WebshopsPage.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
WebshopsPage.permissions = [Permission.ADMIN];

export default WebshopsPage;
